<template>
  <div
    v-if="loadedPage"
    class="receipt-details">
    <ReceiptProgress
      v-if="progress"
      :admin="admin"
      :titles="true"
      :receipt="receipt"/>
  </div>
</template>

<script>
import ReceiptProgress from '../ReceiptProgress/ReceiptProgress.vue';

export default {
  name: "ReceiptDetails",
  components: {
    ReceiptProgress,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    receipt: {
      type: Object,
      default: () => ({}),
    },
    progress: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    userType() {
      return this.admin ? 'Admin' : 'Company';
    },
    routesName() {
      return this.admin ? 'Admin' : 'Partner';
    },
    hasIssue() {
      return !!this.receipt.receipt_issue && this.receipt.receipt_issue !== 'none';
    },
    stepNumber() {
      let stepNumber = 0;
      const activation = this.receipt.activation;
      let theReceipt = this.receipt;
      if (theReceipt.cta_issue) {
        stepNumber = 7;
      } else if (activation.receipt_step && !theReceipt.confirmed_receipt) {
        stepNumber = 0;
      } else if (activation.registration_step && !theReceipt.confirmed_registration) {
        stepNumber = 1;
      } else if (activation.survey_step && !theReceipt.confirmed_survey) {
        stepNumber = 2;
      } else if (activation.address_step && !theReceipt.confirmed_address) {
        stepNumber = 3;
      } else if (activation.payment_step && !theReceipt.confirmed_payment) {
        stepNumber = 4;
      } else if (activation.review_step && !theReceipt.confirmed_review) {
        stepNumber = 5;
      } else if (activation.cashback_step && !theReceipt.confirmed_cashback) {
        stepNumber = 6;
      } else {
        stepNumber = 7;
      }

      return stepNumber;
    },
  },
  data() {
    return {
      loadedPage: true,
    };
  },
  watch: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./ReceiptDetails.scss";
</style>
